/**
 * Build the canonical URL for a blog category.
 *
 * Child categories are nested under their parent:
 *   `/blog/category/<parentSlug>/<childSlug>`
 *
 * Root categories use a flat path:
 *   `/blog/category/<slug>`
 */

import { getEntry } from "./guards";

interface CategoryUrlInput {
  fields: {
    slug: string;
    parentCategory?: unknown;
  };
}

export function getCategoryUrl(category: CategoryUrlInput): string {
  const parent = getEntry(category.fields.parentCategory);
  if (parent?.fields?.slug && typeof parent.fields.slug === "string") {
    return `/blog/category/${parent.fields.slug}/${category.fields.slug}`;
  }
  return `/blog/category/${category.fields.slug}`;
}
